import { all } from 'redux-saga/effects'
import ablySagas from './ably/sagas';
import eventsSagas from './events/sagas';
import authSagas from './auth/sagas';
import chartiqSagas from './chart-iq/chart/sagas';
import chartiqDrawSagas from './chart-iq/drawing/sagas';
import chartiqStudySagas from './chart-iq/study/sagas';
import chartSagas from './chart/sagas';
import newsSagas from './news/sagas';
import tableSagas from './table/sagas';

export default function* rootSaga() {
	yield all([
		...chartSagas,
		...authSagas,
		...tableSagas,
		...newsSagas,
		...eventsSagas,
		...chartiqSagas,
		...chartiqDrawSagas,
		...chartiqStudySagas,
		...ablySagas,
	]);
}
